import { SelfServeState } from "./rootReducer";

export const getSupportChatState = (appState: SelfServeState) =>
  appState.selfServe.supportChat;

export const getHasActiveChatSession = (appState: SelfServeState) =>
  getSupportChatState(appState).activeChatSession !== undefined;

export const getIsMinimized = (appState: SelfServeState) =>
  getSupportChatState(appState).isMinimized;

export const getActiveChatMessages = (appState: SelfServeState) =>
  getSupportChatState(appState).activeChatSession?.messages ?? [];

export const getActiveChatSessionId = (
  appState: SelfServeState
): string | undefined => getSupportChatState(appState).activeChatSession?.id;

export const getBottomSheetContent = (appState: SelfServeState) =>
  getSupportChatState(appState).bottomSheetContent;

export const getIsChatFabVisible = (appState: SelfServeState) =>
  getSupportChatState(appState).isFabVisible;

export const getActiveSupportType = (appState: SelfServeState) =>
  getSupportChatState(appState).activeSupportType ?? undefined;
